import apiService from "services/apiservice";
import { call, put, takeLatest } from "redux-saga/effects";
import { loadState, saveState } from "library/helpers/sessionStorage";
import {
    generateDropdownForCustomerVendors,
    getErrorMessageString,
  } from "utils/utils";
import {
  getCustomerCodesFailure,
  getCustomerCodesSuccess,
  getPermissionsFailure,
  getPermissionsSuccess,
  getReferenceNoOptionsFailure,
  getReferenceNoOptionsSuccess,
  getReferencesFailure,
  getReferencesSuccess,
  getServiceTypeLookupFailure,
  getServiceTypeLookupSuccess,
  getVendorsListFailure,
  getVendorsListSuccess,
} from "./actions";
import { ArrayList } from "./types";
import {
  GET_CUSTOMER_CODES_REQUEST,
  GET_PERMISSIONS_REQUEST,
  GET_REFERENCE_NO_OPTIONS_REQUEST,
  GET_REFERENCES_REQUEST,
  GET_SERVICE_TYPE_LOOKUP_REQUEST,
  GET_VENDORS_LIST_REQUEST,
} from "./actionTypes";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const getRequest = async (url: string) => {
  const { data } = await apiService.get(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* getCustomerCodesSaga(action: any) {
  try {
    const response: ArrayList[] = yield call(getRequest, action.url);
    const formattedData = generateDropdownForCustomerVendors(
      response,
      action?.payload,
      "customer"
    );
    yield put(
      getCustomerCodesSuccess({
        customerCodes: formattedData?.commaSeparatedCodes,
        customerDropdownBasedOnBillTo: formattedData?.arrayWithAll,
        masterCustomerDropdownList: formattedData?.completeResponse,
      })
    );
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(
      getCustomerCodesFailure({
        error: errorMessages,
      })
    );
  }
}

function* getPermissionsSaga(action: any) {
  try {
    const response: ArrayList[] = yield call(getRequest, action.url);

    yield put(
      getPermissionsSuccess({
        permissions: response,
      })
    );
    const permissionsMasterList = response?.map((item: any) => ({
      ...item,
      label: item?.module,
    }));
    saveState("permissionsMasterList", permissionsMasterList);
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(
      getPermissionsFailure({
        error: errorMessages,
      })
    );
  }
}
function* getReferenceNoOptionsSaga(action: any) {
  try {
    const response: ArrayList[] = yield call(getRequest, action.url);

    yield put(
      getReferenceNoOptionsSuccess({
        referenceNoOptions: response,
      })
    );
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(
      getReferenceNoOptionsFailure({
        error: errorMessages,
      })
    );
  }
}
function* getReferencesSaga(action: any) {
  try {
    const response: ArrayList[] = yield call(getRequest, action.url);

    yield put(
      getReferencesSuccess({
        references:  response,
      })
    );
    const referencesMasterList = response?.map((item: any) => ({
      ...item,
      label: item?.module,
    }));
    saveState("referencesMasterList", referencesMasterList);
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(
      getReferencesFailure({
        error: errorMessages,
      })
    );
  }
}
function* getVendorsListSaga(action: any) {
  try {
    const response: ArrayList[] = yield call(getRequest, action.url);
    const formattedData = generateDropdownForCustomerVendors(
      response,
      action?.payload,
      "vendor"
    );
    yield put(
      getVendorsListSuccess({
        vendorCodes: formattedData?.commaSeparatedCodes,
        vendorsList: formattedData?.arrayWithAll,
        masterVendorDropdownList: formattedData?.completeResponse,
      })
    );
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(
      getVendorsListFailure({
        error: errorMessages,
      })
    );
  }
}

function* getServiceTypeLookupSaga(action: any) {
  try {
    const response: ArrayList[] = yield call(getRequest, action.url);
    yield put(getServiceTypeLookupSuccess({ serviceTypeLookup: response }));
  } catch (e: any) {
    const errorMessages = getErrorMessageString(e);
    yield put(
      getServiceTypeLookupFailure({
        error: errorMessages,
      })
    );
  }
}

export default function* masterDataSaga() {
  yield takeLatest(GET_CUSTOMER_CODES_REQUEST, getCustomerCodesSaga);
  yield takeLatest(GET_PERMISSIONS_REQUEST, getPermissionsSaga);
  yield takeLatest(GET_REFERENCES_REQUEST, getReferencesSaga);
  yield takeLatest(GET_REFERENCE_NO_OPTIONS_REQUEST, getReferenceNoOptionsSaga);
  yield takeLatest(GET_VENDORS_LIST_REQUEST, getVendorsListSaga);
  yield takeLatest(GET_SERVICE_TYPE_LOOKUP_REQUEST, getServiceTypeLookupSaga);
}
